import React from 'react';
import PropTypes from 'prop-types';
import { Field, FieldLabel, FieldValue } from './SummaryShared';
import i18n from '../../i18n';

const SummaryInstructions = ({ instructions }) => {
  if (!instructions) return null;
  return (
    <Field>
      <FieldLabel>{i18n('translation_order_instructions')}</FieldLabel>
      <FieldValue>{instructions}</FieldValue>
    </Field>
  );
};

SummaryInstructions.propTypes = {
  instructions: PropTypes.string,
};

export default SummaryInstructions;
